const formataData = (date: Date | undefined) => {
  return Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date && new Date(date));
};

export default formataData;
